import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {of, Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {ActivatedRoute, Params} from '@angular/router';
import {QueryProvider} from '@shared/queries/query-provider';
import {ViewMode, Permissions, TokenType} from 'powerbi-models';
import * as pbi from 'powerbi-client';
import {Observable} from 'rxjs';
import {IDashboardState} from '../store/reducer/dashboard-reducer';
import {GetDashboardReportDetails} from '../store/action/dashboard-actions';
import {AnalyticsSelectedItemCommand} from '@shared/commands/dashboard.command';
import {getDashboardReportDetails, getDashboardReportError} from '../store/selector/dashboard-selector';
import {VisualizerNotificationService} from "../Services/visualizer-notification.service";

@Component({
    standalone: false,
    selector: 'particle-dashboard-hitmap',
  templateUrl: './dashboard-hitmap.component.html',
  styleUrls: ['./dashboard-hitmap.component.scss']
})
export class DashboardHitmapComponent implements OnInit {

  currentProject: string;
  unSubscribe$ = new Subject<void>();
  queryKey = 'dashboardHeatmapVisualizer';
  progress: string;
  dataLoaded: boolean;
  unsubscribe$ = new Subject<void>();
  queryParameters: Params;
  toNewDateString: string;
  fromNewsDateString: string;
  inited: boolean = false;
  errorInit: boolean = false;
  failureResponse: boolean;
  failureResponse$: Observable<boolean>;
  loadingPercentage: any = {};
  intervalTimer: any;
  private report: any;
  private reportTypeFromQuery: string;

  constructor(private activatedRoute: ActivatedRoute, private dashboardStore: Store<IDashboardState>, private visualizerNotificationService : VisualizerNotificationService) {
  }

  ngOnInit() {
    this.failureResponse = false;
    this.failureResponse$ = of(this.failureResponse);
    this.loadingAnimation();
    this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe((queryParams: any) => {
      if(queryParams && queryParams.reportType){
        this.reportTypeFromQuery = queryParams.reportType;
      }
      if (queryParams && queryParams.fromDate && queryParams.toDate) {
        this.queryParameters = {...queryParams};
        if (this.failureResponse || (queryParams.fromDate !== this.fromNewsDateString || queryParams.toDate !== this.toNewDateString)) {
          this.loadingAnimation();
          this.fromNewsDateString = queryParams.fromDate;
          this.toNewDateString = queryParams.toDate;
          this.failureResponse = false;
          this.failureResponse$ = of(this.failureResponse);
          this.dataLoaded = false;
          /*QueryProvider.invokeQuery(this.queryStore, this.queryKey, {
           '[FROM_DATE]': queryParams.fromDate, '[TO_DATE]': queryParams.toDate
           });*/
          const endpointUrl = QueryProvider.getPostCommandFullUrl(this.queryKey);
          const command = new AnalyticsSelectedItemCommand(endpointUrl);
          command.fromDate = this.fromNewsDateString;
          command.toDate = this.toNewDateString;
          this.dashboardStore.dispatch(new GetDashboardReportDetails(command));
        }
      }
    });
    this.dashboardStore.pipe(select(getDashboardReportDetails), takeUntil(this.unsubscribe$)).subscribe((payload: any) => {
      if (this.inited) {
        if (payload) {
          this.failureResponse = false;
          this.failureResponse$ = of(this.failureResponse);
          this.dataLoaded = true;
          const reportId = payload.ReportId;
          const groupId = payload.GroupId;
          const embedToken = payload.EmbedToken;
          this.displayReport(reportId, groupId, embedToken);
        }
      } else {
        this.failureResponse = false;
        this.failureResponse$ = of(this.failureResponse);
        this.dataLoaded = false;
      }
      this.inited = true;
    })
    this.dashboardStore.pipe(select(getDashboardReportError), takeUntil(this.unsubscribe$)).subscribe(payload => {
      if (payload && this.errorInit) {
        this.failureResponse = true;
        this.failureResponse$ = of(this.failureResponse);
        this.dataLoaded = false;
      }
      this.errorInit = true;
    })
  }

  displayReport(reportID, groupID, embedToken) {
    const config = <pbi.IEmbedConfiguration> {
      type: 'report',
      tokenType: TokenType.Embed,
      viewMode: ViewMode.View,
      permissions: Permissions.All,
      uniqueId: reportID,
      embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=' + reportID + '&groupId=' + groupID,
      settings: {filterPaneEnabled: false},
      accessToken: embedToken
    };

    // Grab the reference to the div HTML element that will host the report.
    const reportsContainer = <HTMLElement>document.getElementById('reportsContainer');

    // Embed the report and display it within the div container.
    const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    if (reportsContainer) {
      powerbi.reset(reportsContainer);
      this.report = powerbi.embed(reportsContainer, config);
    }
    if(this.reportTypeFromQuery){
      this.goToPage(this.reportTypeFromQuery);
      this.reportTypeFromQuery = null;
    }
  }
  goToPage( pageName){
    this.report.on('loaded', event=>{
      this.report.getPages().then(pages=>{
        pages.forEach(page=>{
          if(page.displayName === pageName){
            page.setActive().then(()=>{
              console.log(`Active page has been set to ${page.displayName}`);
            }).catch(error=>{
              console.log(`Error: ${error}. Can't set page to ${page.displayName}`);
            })
          }
        })
      })
    })
  }
  loadingAnimation() {
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
    this.loadingPercentage.background = 'linear-gradient(to top, #337aee 0%, #eee 0%)';
    let timeInterval = 0;
    this.intervalTimer = setInterval(() => {
      timeInterval = timeInterval + 1.67;
      let timeIntervalString = timeInterval.toString() + '%';
      let backgroundGradient = `linear-gradient(to top, #337aee ${timeIntervalString}, #eee 0%`;
      this.loadingPercentage.background = backgroundGradient;
      //console.log(this.loadingPercentage.background);
      if (timeInterval >= 100 || this.dataLoaded || this.failureResponse) {
        clearInterval(this.intervalTimer);
      }
    }, 1000);
  }

  ngOnDestroy() {
    this.visualizerNotificationService.destroyPulling();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
